@if (editable()) {
  <div class="doc-upload-panel__drops">
    @for (dt of docTypes(); track dt.value) {
      <app-doc-drop
        [docType]="dt"
        [uploads]="uploadsByType(dt.value)"
        [disabled]="disabled()"
        [deletingIds]="deletingIds()"
        (filesPicked)="onFilesPicked(dt.value, $event)"
        (remove)="removeUpload($event)"
      />
    }
  </div>
} @else if (uploads().length === 0) {
  <p class="doc-upload-panel__empty">No documents were uploaded.</p>
} @else {
  <ul class="doc-upload-panel__list">
    @for (u of uploads(); track u.id) {
      <li>
        <app-doc-verdict
          [fileName]="u.fileName"
          [status]="u.doc?.assess_status ?? 'PENDING'"
          [message]="u.doc?.assess_message ?? ''"
        />
      </li>
    }
  </ul>
}
